export const ASSESSMENT_CYCLES = 'assessmentCycles';
export const GET_ASSESSMENT_CYCLES = `${ASSESSMENT_CYCLES}/getAssessmentCyclesAction`;
export const GET_ASSESSMENT_CYCLES_LIST = `${ASSESSMENT_CYCLES}/getAssessmentCyclesList`;
export const GET_ASSESSMENT_CYCLE = `${ASSESSMENT_CYCLES}/getAssessmentCycleAction`;
export const SET_ASSESSMENT_CYCLES = `${ASSESSMENT_CYCLES}/setAssessmentCyclesAction`;
